<script>
export default {
  props: ['visible', 'value'],
  computed: {
    show () {
      if(!this.visible) return true;
      var cond = this.visible.split("=");
      console.log(cond, _.get(this.value, cond[0]));
      if(cond[1] == "true") cond[1] = true;
      if(cond[1] == "false") cond[1] = false;

      return _.get(this.value, cond[0]) == cond[1];
    }
  }
}
</script>
